import moment from 'moment';
import getCurrentTimezoneOffset from './getCurrentTimezoneOffset';

export default function formatTimeString(str, format = "HH:mm"){
    return moment(str, "HH:mm:ss").add(getCurrentTimezoneOffset(), 'minute').format(format);
}